export default __webpack_public_path__ + "static/media/recruit_table_icon_8.a1523d73.svg";